import styles from './MotivoTable.module.css'
import EditButton from '../layout/EditButton'
import RemoveButton from '../layout/RemoveButton'

function  MotivoTable({motivos, handleRemove }) {

    const remove = (e) => {
        e.preventDefault()
        handleRemove(e.target.value)
    }

    return (
            <div className={styles.tableWrapper}>
            <table className={styles.motivosTable}>
                <thead>
                <tr>
                    <th colSpan='2' className={styles.motivosTableIndice}>Ações</th>
                    <th className={styles.motivosTableID}>ID</th>
                    <th className={styles.motivosTableDescricao}>Descrição</th>
                    <th className={styles.motivosTableIndice}>Status</th>
                </tr>
                </thead>
                <tbody>
                {motivos.length > 0 &&
                motivos.map((mtv) => {
                    const inativo = mtv.DT_EXCLUSAO != null
                        return (
                        <tr key={mtv.ID}>
                            <td className={styles.motivoTableActions} colSpan={inativo ? 2 : 1}>
                                <EditButton to={`/motivo/${mtv.ID}`}/>
                            </td>
                            {!inativo && (<td className={styles.motivoTableActions}><RemoveButton to={remove}/></td>)}
                            <td className={styles.motivoTableID}>{mtv.ID}</td>
                            <td className={styles.motivoTableDesc}>{mtv.TX_MOTIVO}</td>
                            <td className={styles.motivoTableStatus}>
                                <span className={inativo ? styles.statusPillInativo : styles.statusPillAtivo}>
                                    {inativo ? 'Inativo' : 'Ativo'}
                                </span>
                            </td>
                        </tr>
                        )}
                        )
                    }
                </tbody>
            </table>
            </div>
        )

    }

export default MotivoTable
